import { coreApi } from '../../utils/axios';
import { CreateVirtualMedicineResponse, GetVirtualMedicineResponse, GetVirtualMedicinesResponse, VirtualMedicine } from './types';

export const getVirtualMedicines = (masterMedicineId: string) => {
  return coreApi.get<GetVirtualMedicinesResponse>(`/virtual-medicines?master_medicine_id=${masterMedicineId}`);
};

export const updateVirtualMedicine = (id: string, data: Partial<VirtualMedicine>) => {
  return coreApi.put(`/virtual-medicines/${id}`, data);
};

export const getVirtualMedicine = (id: string) => {
  return coreApi.get<GetVirtualMedicineResponse>(`/virtual-medicines/${id}`);
};

export const createVirtualMedicine = (data: Partial<VirtualMedicine>) => {
  return coreApi.post<CreateVirtualMedicineResponse>('/virtual-medicines', data);
}

export const deleteVirtualMedicine = (id: string) => {
  return coreApi.delete(`/virtual-medicines/${id}`);
}